import { Dimmer, Loader } from '@mairistem/composants';

import type { TileBasePropsType } from '../types';

const TileBase = ({ children, className = '', loading = false, style }: TileBasePropsType) => (
  <div className={`tile-base ${className}`} style={style}>
    <Dimmer active={loading} inverted>
      <Loader inverted />
    </Dimmer>
    {children}
  </div>
);

export default TileBase;
